export const CMS_CUSTOMER_PLAN_FALLBACK = {
  endpoint: '/home/customer-assurance/customer-service-plan',
  name: 'customer-service-plan',
  data: {
    description:
      'When you book flights or travel on JetBlue, you can trust us to put your safety and security above all else. Review the JetBlue Customer Bill of Rights here.',
    title: 'Customer Service Plan',
    personalizationTrait: '',
  },
  area: [
    {
      component: [
        {
          name: 'breadcrumbs',
          data: {
            breadcrumbs: [
              {
                name: 'Customer Service Plan',
                href: '/customer-assurance/customer-service-plan',
                parentPages: [
                  { name: 'Customer Assurance', href: '/customer-assurance' },
                  { name: 'Home', href: '' },
                ],
              },
            ],
          },
        },
        {
          name: 'pageHeader',
          data: {
            pageHeader: [
              {
                title: 'Customer Service Plan',
                content:
                  'From our first flight in 2000, JetBlue has been dedicated to inspiring humanity and creating the best travel experience possible—even when things don’t go as planned. The Customer Service Plan is our promise that we don’t just have your legroom—we have your back.',
              },
            ],
          },
        },
      ],
    },
    {
      component: [
        {
          name: 'sectionHeader',
          data: {
            enableSelector: 'true',
            sectionHeader: [
              {
                name: 'section',
                data: {
                  theme: 'light',
                  layout: 'left',
                  bgColor: '#f6f6f6',
                  title: 'Notice',
                  section: [
                    {
                      name: 'bodyText',
                      data: {
                        theme: 'light',
                        bodyText: [
                          {
                            content:
                              '<p>These provisions apply only to JetBlue operated flights. In addition, these provisions apply only to JetBlue Passengers (referred to herein as “Customer”) as defined by the JetBlue <a href="/magnoliapublic/dam/ui-assets/p/contract_of_carriage.pdf" target="_self" type="external">Contract of Carriage</a> and who have checked in for the JetBlue flight. “<a href="/magnoliapublic/dam/ui-assets/p/contract_of_carriage.pdf" target="_self" type="external">Controllable Irregularity</a>” is defined in JetBlue’s Contract of Carriage. Any and all requests for eligible reimbursement hereunder must be accompanied by detailed receipts submitted within 10 days’ time of such expenses being incurred.</p>\n',
                            title:
                              'initial notice customer service plan our promises opening paragraph',
                            link: [
                              {
                                newWindow: '_self',
                                href: '/customer-assurance/customer-bill-of-rights',
                                title: 'Customer Bill of Rights',
                                type: 'internal',
                              },
                            ],
                          },
                        ],
                        layout: 'left',
                      },
                    },
                  ],
                },
              },
              {
                name: 'section',
                data: {
                  theme: 'light',
                  layout: 'left',
                  bgColor: '#fff',
                  title: 'Delays',
                  section: [
                    {
                      name: 'bodyText',
                      data: {
                        theme: 'light',
                        bodyText: [
                          {
                            content:
                              '<h3>Departure Delays</h3>\n\n<p>If a JetBlue flight is delayed 3 hours or more from scheduled departure time and the delay is due to a <a href="/magnoliapublic/dam/ui-assets/p/contract_of_carriage.pdf" target="_self" type="external">Controllable Irregularity</a>, JetBlue will, at the customer’s request and at no additional charge or fare to the customer, rebook the customer on the next available JetBlue flight, rebook the customer on the next available partner airline flight, or refund the customer.</p>\n\n<p>Customers whose flight is delayed due to a <a href="/magnoliapublic/dam/ui-assets/p/contract_of_carriage.pdf" target="_self" type="external">Controllable Irregularity</a> are entitled to compensation good for future travel on JetBlue:</p>\n',
                            title: 'our promises updated departure delays',
                          },
                        ],
                        layout: 'left',
                      },
                    },
                    {
                      name: 'table',
                      data: {
                        table: [
                          {
                            fixHeader: 'true',
                            sortable: 'true',
                            tableName: 'our-promise delays table',
                            type: 'simple',
                            headers: [
                              { headerName: 'Delay time:', id: 1 },
                              { headerName: 'Compensation amount', id: 2 },
                            ],
                            rows: [
                              {
                                id: 1,
                                rowData: [
                                  {
                                    columnId: 1,
                                    id: 1,
                                    type: 'string',
                                    value: '3-3:59 hours:',
                                  },
                                  {
                                    columnId: 2,
                                    id: 2,
                                    type: 'string',
                                    value: '$50 Credit',
                                  },
                                ],
                              },
                              {
                                id: 2,
                                rowData: [
                                  {
                                    columnId: 1,
                                    id: 3,
                                    type: 'string',
                                    value: '4-4:59 hours:',
                                  },
                                  {
                                    columnId: 2,
                                    id: 4,
                                    type: 'string',
                                    value: '$100 Credit',
                                  },
                                ],
                              },
                              {
                                id: 3,
                                rowData: [
                                  {
                                    columnId: 1,
                                    id: 5,
                                    type: 'string',
                                    value: '5-5:59 hours:',
                                  },
                                  {
                                    columnId: 2,
                                    id: 6,
                                    type: 'string',
                                    value: '$150 Credit',
                                  },
                                ],
                              },
                              {
                                id: 4,
                                rowData: [
                                  {
                                    columnId: 1,
                                    id: 7,
                                    type: 'string',
                                    value: '6 or more hours:',
                                  },
                                  {
                                    columnId: 2,
                                    id: 8,
                                    type: 'string',
                                    value: '$200 Credit',
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      name: 'bodyText',
                      data: {
                        theme: 'light',
                        bodyText: [
                          {
                            content:
                              '<p><strong>If a JetBlue flight is delayed 3hrs or more from scheduled departure time and the delay is due to a</strong> <a href="http:///magnoliapublic/dam/ui-assets/p/contract_of_carriage.pdf" target="_self" type="external">Controllable Irregularity</a>, JetBlue will, at the Customer’s request and at no additional charge or fare to the Customer, rebook the Customer on the next available JetBlue flight or refund the Customer.</p>\n\n<p><strong>If a JetBlue flight is delayed 3hrs or more from scheduled departure time and the delay is due to a</strong> <a href="http:///magnoliapublic/dam/ui-assets/p/contract_of_carriage.pdf" target="_self" type="external">Controllable Irregularity</a>, JetBlue will, at the Customer\'s request and at no additional charge or fare to the Customer, rebook the Customer on the next available partner airline flight, or as provided in the section above, rebook the Customer on the next available JetBlue flight or refund the Customer. </p>\n\n<p><strong>If a JetBlue flight is delayed 3 hours or more from scheduled departure time and the delay is due to a</strong> <a href="/magnoliapublic/dam/ui-assets/p/contract_of_carriage.pdf" style="color:#954f72; text-decoration:underline">Controllable Irregularity</a>, JetBlue will provide the customer a meal voucher of $12.00 including taxes and fees. In the event that a meal voucher is not available or otherwise accepted in an airport, or food or beverages are not otherwise available in an airport (e.g., the concessions are closed), JetBlue will make best efforts to provide an appropriate meal/ beverage to the customer (e.g., order food and provide water for the delayed flight) or otherwise reimburse the customer, subject to valid receipts, for expenses associated with meals/beverages not to exceed the allowable limit of the JetBlue meal voucher. Any and all requests for eligible reimbursement must be accompanied by detailed receipts submitted within 10 days’ time of such expenses being incurred.</p>\n\n<p><strong>If a JetBlue flight is delayed 3 hours or more from scheduled departure time and the delay is due to a</strong> <a href="/magnoliapublic/dam/ui-assets/p/contract_of_carriage.pdf" style="color:#954f72; text-decoration:underline">Controllable Irregularity</a> which results in the customer not being reaccommodated until the following day or days, JetBlue will offer reasonable overnight hotel accommodations in a local airport area hotel. If hotel accommodations at a local area hotel are not available, JetBlue will, subject to valid receipts, reimburse the customer reasonable and appropriate expenses associated with the overnight hotel accommodations. Any and all requests for eligible reimbursement must be accompanied by detailed receipts submitted within 10 days’ time of such expenses being incurred.</p>\n\n<p><strong>If a JetBlue flight is delayed 3 hours or more from scheduled departure time and the delay is due to a </strong><a href="/magnoliapublic/dam/ui-assets/p/contract_of_carriage.pdf" style="color:#954f72; text-decoration:underline">Controllable Irregularity</a> which results in the customer not being reaccommodated until the following day, JetBlue will offer ground transportation from the airport to/from a local airport area hotel.  If JetBlue is unable to secure ground transportation, it will reimburse the customer, subject to receipts, an amount consistent with the reasonable rate for ground transportation to and from the hotel. Any and all requests for eligible reimbursement must be accompanied by detailed receipts submitted within 10 days’ time of such expenses being incurred.<br />\n </p>\n\n<h3>Onboard ground delays</h3>\n\n<p><strong>Customers who experience an onboard Ground Delay on departure</strong>, except those necessitated by a security event, or are subject to an exception provided below, are entitled to compensation good for future travel on JetBlue:</p>\n',
                            title:
                              'departure delays our promises new delays for 3 or more hours onboard delays',
                          },
                        ],
                        layout: 'left',
                      },
                    },
                    {
                      name: 'table',
                      data: {
                        table: [
                          {
                            fixHeader: 'true',
                            sortable: 'true',
                            tableName:
                              'our-promise onboard ground delay on departure table',
                            type: 'simple',
                            headers: [
                              { headerName: 'Delay time:', id: 1 },
                              { headerName: 'Compensation amount', id: 2 },
                            ],
                            rows: [
                              {
                                id: 1,
                                rowData: [
                                  {
                                    columnId: 1,
                                    id: 1,
                                    type: 'string',
                                    value: '3-4:59 hours:',
                                  },
                                  {
                                    columnId: 2,
                                    id: 2,
                                    type: 'string',
                                    value: '$100 Credit',
                                  },
                                ],
                              },
                              {
                                id: 2,
                                rowData: [
                                  {
                                    columnId: 1,
                                    id: 3,
                                    type: 'string',
                                    value: '5-5:59 hours:',
                                  },
                                  {
                                    columnId: 2,
                                    id: 4,
                                    type: 'string',
                                    value: '$175 Credit',
                                  },
                                ],
                              },
                              {
                                id: 3,
                                rowData: [
                                  {
                                    columnId: 1,
                                    id: 5,
                                    type: 'string',
                                    value: '6 or more hours:',
                                  },
                                  {
                                    columnId: 2,
                                    id: 6,
                                    type: 'string',
                                    value: '$250 Credit',
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      name: 'bodyText',
                      data: {
                        theme: 'light',
                        bodyText: [
                          {
                            content:
                              '<p><strong>Customers who experience an onboard Ground Delay on arrival,</strong> except those necessitated by a security event or one subject to an exception provided below, are entitled to compensation good for future travel on JetBlue:</p>\n',
                            title:
                              'our promise Onboard ground delay on arrival',
                          },
                        ],
                        layout: 'left',
                      },
                    },
                    {
                      name: 'table',
                      data: {
                        table: [
                          {
                            fixHeader: 'true',
                            sortable: 'true',
                            tableName:
                              'our-promise onboard ground delay on arrival table',
                            type: 'simple',
                            headers: [
                              { headerName: 'Delay time:', id: 1 },
                              { headerName: 'Compensation amount', id: 2 },
                            ],
                            rows: [
                              {
                                id: 1,
                                rowData: [
                                  {
                                    columnId: 1,
                                    id: 1,
                                    type: 'string',
                                    value: '1-1:59 hours:',
                                  },
                                  {
                                    columnId: 2,
                                    id: 2,
                                    type: 'string',
                                    value: '$50 Credit',
                                  },
                                ],
                              },
                              {
                                id: 2,
                                rowData: [
                                  {
                                    columnId: 1,
                                    id: 3,
                                    type: 'string',
                                    value: '2-2:59 hours:',
                                  },
                                  {
                                    columnId: 2,
                                    id: 4,
                                    type: 'string',
                                    value: '$125 Credit',
                                  },
                                ],
                              },
                              {
                                id: 3,
                                rowData: [
                                  {
                                    columnId: 1,
                                    id: 5,
                                    type: 'string',
                                    value: '3 or more hours:',
                                  },
                                  {
                                    columnId: 2,
                                    id: 6,
                                    type: 'string',
                                    value: '$200 Credit',
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      name: 'bodyText',
                      data: {
                        theme: 'light',
                        bodyText: [
                          {
                            title:
                              'our promise Accommodation during onboard ground delays',
                            content:
                              '<h3>Amenities during onboard ground delays</h3>\n\n<p>JetBlue will provide customers experiencing an onboard ground delay with free seatback entertainment, food and drink, access to clean restrooms and, as necessary, medical treatment. JetBlue will begin to return to the gate or other disembarkation point no later than 3 hours for domestic flights and 4 hours for international flights unless the pilot-in-command determines there is a safety or security-related reason for remaining on the tarmac or Air Traffic Control advises the pilot-in-command that returning to the gate or another disembarkation point elsewhere in order to deplane would significantly disrupt airport operations.</p>\n',
                          },
                        ],
                        layout: 'left',
                      },
                    },
                    {
                      name: 'bodyText',
                      data: {
                        theme: 'light',
                        bodyText: [
                          {
                            content:
                              '<p>JetBlue will notify customers of delays of 30 minutes or more, cancellations and diversions within 30 minutes of the carrier learning about the change. Notification may be given in any of the following forms: via jetblue.com, telephone, flight information display system, airport announcement, onboard announcement, email or text message. The following provisions as well as certain previous provisions around such instances of controllable departure/arrival delays and cancellations do not apply to flights going to/from Canada or originating in the EU or U.K.</p>\n',
                            title:
                              'updated our promises JetBlue will notify customers of delays of 30 minutes or more',
                            link: [
                              {
                                href: '/magnoliapublic/dam/ui-assets/p/contract_of_carriage.pdf',
                                newWindow: '_self',
                                title: 'Contract of Carriage',
                                type: 'internal',
                              },
                              {
                                href: '/magnoliapublic/dam/ui-assets/p/Contingency_Plan_for_Lengthy_Tarmac_Delays.pdf',
                                newWindow: '_self',
                                type: 'internal',
                                title: 'Tarmac Delay Plan',
                              },
                            ],
                          },
                        ],
                        layout: 'left',
                      },
                    },
                    {
                      name: 'bodyText',
                      data: {
                        theme: 'light',
                        bodyText: [
                          {
                            title:
                              'itinerary changes made by jetblue updated our promises',
                            content:
                              '<h3>Itinerary changes made by JetBlue</h3>\n\n<p>Carrier will notify customers in a timely manner of changes to their travel itinerary. For more information, please reference our <a href="/magnoliapublic/dam/ui-assets/p/contract_of_carriage.pdf" style="color:#954f72; text-decoration:underline">Contract of Carriage</a>.</p>\n',
                          },
                        ],
                        layout: 'left',
                      },
                    },
                  ],
                },
              },
              {
                name: 'section',
                data: {
                  theme: 'light',
                  layout: 'left',
                  bgColor: '#f6f6f6',
                  title: 'Cancellations',
                  section: [
                    {
                      name: 'bodyText',
                      data: {
                        theme: 'light',
                        bodyText: [
                          {
                            title: 'updated our promises Cancellations',
                            content:
                              '<p>All customers whose flight is cancelled by JetBlue will, at the customer\'s option:</p>\n\n<ul>\n\t<li>Receive a full refund <strong>or</strong></li>\n\t<li>Receive re-accommodation on the next available JetBlue flight at no additional charge or fare.</li>\n</ul>\n\n<p>If JetBlue cancels a flight due to a <a href="/magnoliapublic/dam/ui-assets/p/contract_of_carriage.pdf" target="_self" type="external">Controllable Irregularity</a> and alternate transportation with a scheduled departure within one hour is unavailable, customers are entitled to compensation good for future travel on JetBlue:</p>\n',
                          },
                        ],
                        layout: 'left',
                      },
                    },
                    {
                      name: 'table',
                      data: {
                        table: [
                          {
                            fixHeader: 'true',
                            sortable: 'true',
                            tableName: 'our-promise cancellations table',
                            type: 'simple',
                            headers: [
                              { headerName: 'Cancellation:', id: 1 },
                              { headerName: 'Compensation amount', id: 2 },
                            ],
                            rows: [
                              {
                                id: 1,
                                rowData: [
                                  {
                                    columnId: 1,
                                    id: 1,
                                    type: 'string',
                                    value: 'Within 4 hours of flight:',
                                  },
                                  {
                                    columnId: 2,
                                    id: 2,
                                    type: 'string',
                                    value: '$50 Credit',
                                  },
                                ],
                              },
                              {
                                id: 2,
                                rowData: [
                                  {
                                    columnId: 1,
                                    id: 3,
                                    type: 'string',
                                    value: 'After scheduled departure:',
                                  },
                                  {
                                    columnId: 2,
                                    id: 4,
                                    type: 'string',
                                    value: '$100 Credit',
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      name: 'bodyText',
                      data: {
                        theme: 'light',
                        bodyText: [
                          {
                            content:
                              '<p><strong>If JetBlue cancels a flight and the cancellation is due to a</strong> <a href="http:///magnoliapublic/dam/ui-assets/p/contract_of_carriage.pdf" target="_self" type="external">Controllable Irregularity</a>, JetBlue will, at the Customer’s request and at no additional charge or fare to the Customer, rebook the Customer on the next available JetBlue flight or refund the Customer.</p>\n\n<p><strong>If JetBlue cancels a flight due to a </strong><a href="http:///magnoliapublic/dam/ui-assets/p/contract_of_carriage.pdf" target="_self" type="external">Controllable Irregularity</a>, JetBlue will at the Customer\'s request and at no additional charge or fare to the Customer, rebook the Customer on the next available partner airline flight, or as provided in the section above, rebook the Customer on the next available JetBlue flight or refund the Customer. </p>\n\n<p><strong>If JetBlue cancels a flight due to a</strong> <a href="/magnoliapublic/dam/ui-assets/p/contract_of_carriage.pdf" style="color:#954f72; text-decoration:underline">Controllable Irregularity</a> <strong>and the customer is delayed 3 hours or more from scheduled departure time,</strong> JetBlue will provide the customer with a meal voucher of $12.00 including taxes and fees. In the event that a meal voucher is not available or otherwise accepted in an airport, or food or beverages are not otherwise available in an airport (e.g., the concessions are closed), JetBlue will make best efforts to provide an appropriate meal/beverage to the customer (e.g., order food and provide water for the delayed flight) or otherwise reimburse the customer, subject to valid receipts, for expenses associated with meals not to exceed the allowable limit of the JetBlue meal vouchers. Any and all requests for eligible reimbursement must be accompanied by detailed receipts submitted within 10 days’ time of such expenses being incurred.</p>\n\n<p><strong>If JetBlue cancels a flight due to a</strong> <a href="/magnoliapublic/dam/ui-assets/p/contract_of_carriage.pdf" target="_self" type="external">Controllable Irregularity</a>, <strong>and it results in the customer not being reaccommodated until the following day or days, </strong>JetBlue will offer reasonable overnight hotel accommodations in a local airport area hotel. If hotel accommodations at a local airport area hotel are not available, JetBlue will, subject to valid receipts, reimburse the customer reasonable and appropriate expenses associated with the overnight hotel accommodations. Any and all requests for eligible reimbursement must be accompanied by detailed receipts submitted within 10 days’ time of such expenses being incurred.</p>\n\n<p><strong>If JetBlue cancels a flight due to a </strong><a href="/magnoliapublic/dam/ui-assets/p/contract_of_carriage.pdf" style="color:#954f72; text-decoration:underline">Controllable Irregularity</a>, <strong>and it results in the customer not being reaccommodated until the following day, </strong>JetBlue will offer ground transportation from the airport to/from a local airport area hotel. If JetBlue is unable to secure ground transportation, it will reimburse the customer, subject to receipts, an amount consistent with the reasonable rate for ground transportation from the airport to/from the hotel. Any and all requests for eligible reimbursement must be accompanied by detailed receipts submitted within 10 days’ time of such expenses being incurred.</p>\n',
                            title:
                              'cancellations compensation controllable irregularity updated our promises',
                          },
                        ],
                        layout: 'left',
                      },
                    },
                    {
                      name: 'bodyTextWithImage',
                      data: {
                        theme: 'light',
                        layout: 'left',
                        bodyTextWithImage: [
                          {
                            title:
                              'updated our promises refund information part 1',
                            content:
                              '<h3>Refund information</h3>\n\n<p>Following receipt of payment from a customer, JetBlue will allow reservations to be held at the quoted fare for at least 24 hours after the reservation is made, if the reservation is made one week or more prior to the flight’s scheduled departure. If such reservation is canceled within 24 hours of booking, payment will be refunded in full to the customer without assessment of a cancellation fee.</p>\n',
                            type: 't3',
                            image: [
                              {
                                src: '/magnoliapublic/dam/ui-assets/imagery/info-assets/Refunds-ticket.svg',
                                height: '0',
                                width: '0',
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      name: 'bodyText',
                      data: {
                        theme: 'light',
                        bodyText: [
                          {
                            content:
                              '<p>For all other reservations, JetBlue’s rules regarding fare refunds are set forth in <a href="/magnoliapublic/dam/ui-assets/p/contract_of_carriage.pdf" target="_self">Section 4 of the Contract of Carriage</a>. Subject to refund rules set forth in Section 4, JetBlue strives to provide credit card refunds promptly and cash or check refunds within 20 days upon receipt of all necessary information. This includes refunds of fees for optional services on flights from which the customer was bumped due to an oversales situation. Some fares are nonrefundable.</p>\n',
                            title: 'Customer Service Plan 4',
                            link: [
                              {
                                href: '/magnoliapublic/dam/ui-assets/p/contract_of_carriage.pdf',
                                newWindow: '_self',
                                title: 'Contract of Carriage',
                                type: 'internal',
                              },
                            ],
                          },
                        ],
                        layout: 'left',
                      },
                    },
                    {
                      name: 'bodyText',
                      data: {
                        theme: 'light',
                        bodyText: [
                          {
                            title: 'Compensation',
                            content:
                              '<h3>Compensation</h3>\n\n<p><strong>For travel booked directly through JetBlue:</strong></p>\n\n<ul>\n\t<li>If your flight qualifies for compensation, you will receive an email from JetBlue within seven days of your flight\'s scheduled departure. This will happen automatically and there is no need to contact JetBlue.</li>\n</ul>\n\n<p><strong>For travel not booked directly through JetBlue:</strong></p>\n\n<ul>\n\t<li>We may not have your contact information so if your flight qualifies for compensation, please <a href="/contact-us/chat" target="_self" type="external">contact us</a> seven days or more after your flight\'s scheduled departure to inquire about potential compensation.</li>\n</ul>\n',
                          },
                        ],
                        layout: 'left',
                      },
                    },
                    {
                      name: 'bodyText',
                      data: {
                        theme: 'light',
                        bodyText: [
                          {
                            content:
                              '<h3>Travel Bank credits</h3>\n\n<p><strong>Have a JetBlue travel credit?</strong><br />\nLearn how to use it for a booking, view your Travel Bank balance, expiration dates, transaction history and more.</p>\n',
                            title: 'travel bank credits updated our promises',
                            link: [
                              {
                                newWindow: '_self',
                                href: '/help/travel-bank-credits',
                                title: 'JetBlue travel credit info',
                                type: 'internal',
                              },
                            ],
                          },
                        ],
                        layout: 'left',
                      },
                    },
                    {
                      name: 'bodyText',
                      data: {
                        theme: 'light',
                        bodyText: [
                          {
                            title:
                              '>Flights Originating in the European Union/UK, Canada or Guadeloupe',
                            content:
                              '<h3 style="margin-left:0.5in; margin-right:0in">Originating in the EU/U.K./Guadeloupe or going to/from Canada</h3>\n\n<p style="margin-left:0.5in; margin-right:0in">If you were traveling on a confirmed reservation from the European Union (or a European Community Member State), U.K., or Guadeloupe on a JetBlue-operated flight, or to/from Canada on a JetBlue operated flight, and the flight was delayed or canceled, or you were denied boarding, you may be entitled to benefits or recovery under <a href="https://eur-lex.europa.eu/LexUriServ/LexUriServ.do?uri=CELEX:32004R0261:en:HTML" target="_blank" type="external">EC Regulation 261/2004</a>, <a href="https://www.caa.co.uk/uk-regulations/other/consumer-protection/" target="_blank" type="external">UK 261</a> or <a href="https://rppa-appr.ca/eng/right/flight-delays-and-cancellations" target="_blank" type="external">Canadian Traveler Rights</a> in lieu of benefits or compensation provided under this Plan. Customers denied boarding on the basis of health, safety, security or other reasons provided in Sections 24.F and 27.D of the <a href="/magnoliapublic/dam/ui-assets/p/contract_of_carriage.pdf" target="_blank" type="external">JetBlue Contract of Carriage</a> may not be entitled to these rights. Please <a href="https://jetbluevoc.co1.qualtrics.com/jfe/form/SV_6gQoaNYRuosY08l" target="_blank" type="external">submit this claim form</a> if you believe you\'re eligible. </p>\n',
                          },
                        ],
                        layout: 'left',
                      },
                    },
                  ],
                },
              },
              {
                name: 'section',
                data: {
                  theme: 'light',
                  layout: 'left',
                  bgColor: 'bg-white',
                  title: 'Bag info',
                  section: [
                    {
                      name: 'bodyText',
                      data: {
                        theme: 'light',
                        bodyText: [
                          {
                            content:
                              '<p>JetBlue will make every reasonable effort to return mishandled bags within 24 hours. We will reimburse customers for reasonable expenses that occur because of any delay on domestic flights (or as required by international agreements on international flights), and will reimburse customers for any fees associated with the transportation of a lost bag.</p>\n',
                            title: 'Customer Service Plan 3',
                            link: [
                              {
                                newWindow: '_self',
                                href: '/help/bag-claims',
                                type: 'internal',
                                title: 'Learn about bag claims',
                              },
                            ],
                          },
                        ],
                        layout: 'left',
                      },
                    },
                    {
                      name: 'bodyTextWithImage',
                      data: {
                        theme: 'light',
                        layout: 'left',
                        bodyTextWithImage: [
                          {
                            type: 't4',
                            content:
                              '<p>JetBlue will make every reasonable effort to return mishandled bags within 24 hours. We will reimburse customers for reasonable expenses that occur because of any delay on domestic flights (or as required by international agreements on international flights), and will reimburse customers for any fees associated with the transportation of a lost bag.</p>\n',
                            title: 'bag info bag claims updated our promises',
                            image: [
                              {
                                src: '/magnoliapublic/dam/ui-assets/imagery/info-assets/Checked-Bag-Large.svg',
                                height: '0',
                                width: '0',
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      name: 'bodyText',
                      data: {
                        theme: 'light',
                        bodyText: [
                          {
                            content:
                              "<p>Customers who purchased their tickets on a Blue, Blue Extra or Mint fare, or who purchased an Even More Space seat (on all legs, if connecting), on a JetBlue-operated flight within the U.S., have our word that your carry-on bag will be accommodated on board—or you'll receive a $25 credit good for travel on JetBlue for one year from date of issuance. Your carry-on bag must meet the usual carry-on requirements regarding size, weight, contents (no liquids), etc. This guarantee does not apply to those traveling on a Blue Basic fare or on a non-revenue booking other than a TrueBlue redemption.</p>\n",
                            title: 'carry-on bag',
                          },
                        ],
                        layout: 'left',
                      },
                    },
                  ],
                },
              },
              {
                name: 'section',
                data: {
                  theme: 'light',
                  layout: 'left',
                  bgColor: '#f6f6f6',
                  title: 'Inflight Entertainment and Wi-Fi',
                  content:
                    'JetBlue offers free live TV¹, movies and high-speed wi-fi² at every seat. If seatback entertainment is inoperable, customers are entitled to a $15 credit good for future travel on JetBlue.',
                },
              },
              {
                name: 'section',
                data: {
                  theme: 'light',
                  layout: 'left',
                  bgColor: '#fff',
                  title: 'Best Fare Guarantee',
                  content:
                    "We guarantee it! The lowest JetBlue fares are always here on jetblue.com. And if by any chance you find a lower JetBlue fare elsewhere on the same day of purchase, we'll give you a $50 credit good for travel on JetBlue and refund the fare difference.",
                  section: [
                    {
                      name: 'bodyText',
                      data: {
                        theme: 'light',
                        bodyText: [
                          {
                            title: 'Best fare guarantee',
                            content:
                              '<h3>How it works</h3>\n\n<p>In order to receive credit for a lower JetBlue fare found, you must do all of the following:</p>\n\n<ul>\n\t<li>Purchase a fare online at <a href="http://jetblue.com/" style="color:#954f72; text-decoration:underline">jetblue.com</a>. Find the exact same flight(s), itinerary, date(s), number of travelers and seat type on another US point of sale website in US Dollars for at least $5 lower than both (1) the price you paid (including taxes and fees) and (2) the price currently on <a href="http://jetblue.com/" style="color:#954f72; text-decoration:underline">jetblue.com</a>. Does not include differences due to upgrades such as Even More Legroom.</li>\n\t<li><a href="/contact-us/chat" target="_self" type="external">Contact us</a> by 11:59 p.m. ET on the same day of purchase.</li>\n\t<li>Provide the confirmation number of your jetblue.com purchase, the lower fare and the exact URL where you found it.</li>\n\t<li>Customer Support must be able to locate the lower JetBlue fare during your phone call.</li>\n\t<li>Once the lower JetBlue fare is verified, a $50 credit will be issued within 24 hours.</li>\n\t<li>Credit will be forfeited if the customer refunds the booking.</li>\n\t<li>Credits are nontransferable, valid for one year from date of issuance, and good for future travel only. They cannot be applied toward the current flight purchase.</li>\n\t<li>Applies only to un-flown, one-way and roundtrip flights originating in the U.S. Does not apply to refundable fares, code-share or interline travel.</li>\n\t<li>The Guarantee does not apply to airfares where the carrier or itinerary details are unknown until after purchase.</li>\n\t<li>Applies only to online fares available to the general public and with no special discounts.</li>\n\t<li>Excludes corporate bookings, group bookings and JetBlue Vacation packages.</li>\n\t<li>JetBlue reserves the right to deny any claims that cannot be reasonably verified, or for which you have provided incomplete information.</li>\n</ul>\n',
                          },
                        ],
                        layout: 'left',
                      },
                    },
                    {
                      name: 'bodyText',
                      data: {
                        theme: 'light',
                        bodyText: [
                          {
                            title: 'overbookings info updated our promises ',
                            content:
                              '<h3>Overbookings</h3>\n\n<p>As defined in JetBlue\'s <a href="/magnoliapublic/dam/ui-assets/p/contract_of_carriage.pdf" target="_self" type="external">Contract of Carriage</a>, customers who are involuntarily denied boarding shall receive $1,550. These Rights are subject to JetBlue\'s Contract of Carriage and, as applicable, the operational control of the flight crew, and apply to only JetBlue operated flights.</p>\n\n<p>This document is representative of what is reflected in JetBlue\'s Contract of Carriage, the legally binding document between JetBlue and its customers.</p>\n',
                          },
                        ],
                        layout: 'left',
                      },
                    },
                  ],
                },
              },
              {
                name: 'section',
                data: {
                  theme: 'light',
                  layout: 'left',
                  bgColor: '#f6f6f6',
                  title: 'Customer Accessibility',
                  section: [
                    {
                      name: 'bodyText',
                      data: {
                        theme: 'light',
                        bodyText: [
                          {
                            content:
                              '<p>JetBlue has signed on to the <a href="https://www.airlines.org/wp-content/uploads/2022/10/Our-Commitment-to-Passenger-Accessibility_Final.pdf" target="_blank" type="external">Airlines For America Passenger Accessibility Commitment</a> and is proud to be among the member airlines committed to further improving the experience for customers with disabilities across the industry and to ensuring every customer feels welcome, comfortable, and valued.</p>\n\n<p>In addition, JetBlue will accommodate customers with disabilities consistent with its obligations under 14 C.F.R. Part 382.</p>\n\n<p>For more information, please see JetBlue’s <a href="/at-the-airport/accessibility-assistance" target="_self" type="external">Accessibility Assistance page</a> or <a href="/magnoliapublic/dam/ui-assets/p/contract_of_carriage.pdf" target="_self" type="external">Contract of Carriage</a>.</p>\n\n<p>Have an accessibility-related concern? Please call us at 1-855-ADA-LINE (232-5463) and ask to speak with a CRO. </p>\n',
                            title:
                              'customer accessibility updated our promises',
                          },
                        ],
                        layout: 'left',
                      },
                    },
                  ],
                },
              },
              {
                name: 'section',
                data: {
                  theme: 'light',
                  layout: 'left',
                  bgColor: 'bg-white',
                  title: 'Contacting JetBlue',
                  section: [
                    {
                      name: 'bodyTextWithImage',
                      data: {
                        theme: 'light',
                        layout: 'left',
                        bodyTextWithImage: [
                          {
                            content:
                              '<p>JetBlue is dedicated to customer service. If you have a complaint, you can reach us via our <a href="/contact-us/chat" target="_self" type="external">contact us</a> page. All complaints will receive a written acknowledgement of receipt within 30 days of receipt, and provide a substantive response to the complaint within 60 days of receipt.</p>\n\n<p>Have an accessibility-related concern? Please call us at 1-855-ADA-LINE (232-5463) and ask to speak with a CRO. </p>\n',
                            type: 't4',
                            title:
                              'contacting jetblue airways updated our promises',
                            image: [
                              {
                                src: '/magnoliapublic/dam/ui-assets/imagery/info-assets/Contact-Us-Mobile-Device.svg',
                                height: '0',
                                width: '0',
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      name: 'bodyTextWithImage',
                      data: {
                        theme: 'light',
                        layout: 'left',
                        bodyTextWithImage: [
                          {
                            title:
                              'contacting JetBlue Vacations updated our promises',
                            type: 't3',
                            content:
                              '<h3>JetBlue Vacations 360 support</h3>\n\n<p>When you travel with JetBlue Vacations, we strive to make every part of your trip feel like, well, a vacation. Unfortunately, there are times when things do not go as planned. If you\'re inconvenienced as a result, we think it’s important that you know exactly what you can expect from us. That\'s why we offer customers around-the-clock <a href="https://www.jetbluevacations.com/why-jetblue-vacations/travel-experts" target="_blank" type="external">360 Support</a> to ensure you\'ll enjoy peace of mind on every vacation you book.</p>\n\n<p>Have an accessibility-related concern? Please call us at 1-855-ADA-LINE (232-5463) and ask to speak with a CRO. </p>\n',
                            image: [
                              {
                                src: '/magnoliapublic/dam/ui-assets/imagery/info-assets/Contact-JetBlue-Vactions-360.svg',
                                height: '0',
                                width: '0',
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
    {
      component: [
        {
          name: 'legalBlock',
          data: {
            legalBlock: [
              {
                content:
                  '<ol>\n\t<li>DIRECTV service may not be available on flights outside the continental United States; however, where applicable, movies and/or other complimentary stored content remain available on these routes.</li>\n\t<li>Fly-Fi may not be available on certain flights while operating outside of the contiguous U.S.</li>\n</ol>\n',
                title: 'Our Promise Customer Assurance Legal',
              },
            ],
          },
        },
      ],
    },
  ],
};
